export enum BookTour {
  VERIFIEDCUSTOMER = 'verifiedCustomer',
  SCHEDULEDTOUR = 'scheduledTour',
}
